'use client';

import NextLink from 'next/link';
import { FC } from 'react';
import { Button, ButtonProps } from '@/components/ui/button/button';
import useNavigate from '@/hooks/use-navigate';

export type NavigateButtonProps = Omit<ButtonProps, 'onPress' | 'as'> & {
  href: string;
  onPress?: ButtonProps['onPress'];
};

export const NavigateButton: FC<NavigateButtonProps> = ({
  href,
  onPress,
  onMouseEnter,
  ...props
}) => {
  const navigate = useNavigate();

  return (
    <Button
      {...props}
      as={NextLink}
      href={navigate.buildHref(href)}
      onPress={onPress}
      onMouseEnter={e => {
        onMouseEnter?.(e);
        navigate.prefetch(href);
      }}
    />
  );
};
